module.exports = require('react/lib/ReactCSSTransitionGroup');


//////////////////
// WEBPACK FOOTER
// ./~/deere-ui-modal-core/~/react-addons-css-transition-group/index.js
// module id = 5324
// module chunks = 0